__turbopack_context__.v({
  "active": "journeyChallenge-module-scss-module__0sRCUa__active",
  "bars": "journeyChallenge-module-scss-module__0sRCUa__bars",
  "chips": "journeyChallenge-module-scss-module__0sRCUa__chips",
  "completeValue": "journeyChallenge-module-scss-module__0sRCUa__completeValue",
  "drawdown": "journeyChallenge-module-scss-module__0sRCUa__drawdown",
  "gauge": "journeyChallenge-module-scss-module__0sRCUa__gauge",
  "gaugeValue": "journeyChallenge-module-scss-module__0sRCUa__gaugeValue",
  "objectives": "journeyChallenge-module-scss-module__0sRCUa__objectives",
  "passed": "journeyChallenge-module-scss-module__0sRCUa__passed",
  "pointerLayer": "journeyChallenge-module-scss-module__0sRCUa__pointerLayer",
  "rail": "journeyChallenge-module-scss-module__0sRCUa__rail",
  "scene": "journeyChallenge-module-scss-module__0sRCUa__scene",
  "under": "journeyChallenge-module-scss-module__0sRCUa__under",
});
